import React, { useMemo } from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import FlexTable from "../../../components/ui-components/FlexTable";
import { humanEUR, signedPct } from "./format";

const columns = [
  { Header: "Metric", accessor: "label" },
  { Header: "Value", accessor: "value", align: "right" },
];

/**
 * SpendTableBlock - actual / forecast / variance / plan-to-date for the period.
 *
 * GET /api/v1/financial-control/summary -> { summary: { kpis: { spend_vs_forecast } } }
 * (financialcontrol.SpendVsForecastKPI). Uses humanEUR (not the exact-euro forecast-
 * explorer formatter) to match FinancialControlPage's own rendering of these same
 * fields (src/views/cost-control/format.js buildTiles).
 */
const SpendTableBlock = ({ title = "Spend vs. plan", period }) => {
  const { data, isLoading, error } = useBlockData("/api/v1/financial-control/summary", {
    params: period ? { period } : undefined,
  });

  const kpi = data?.summary?.kpis?.spend_vs_forecast;

  const rows = useMemo(
    () => [
      { id: "actual", label: "Actual", value: humanEUR(kpi?.actual) },
      { id: "forecast", label: "Forecast", value: humanEUR(kpi?.forecast) },
      { id: "variance", label: "Variance", value: signedPct(kpi?.variance) },
      { id: "plan_to_date", label: "Plan-to-date", value: humanEUR(kpi?.plan_to_date) },
    ],
    [kpi]
  );

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error}>
      <FlexTable columns={columns} data={rows} getRowId={(row) => row.id} />
    </BaseBlock>
  );
};

SpendTableBlock.propTypes = {
  title: PropTypes.string,
  period: PropTypes.string,
};

export default SpendTableBlock;
